import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaLinkedinIn,
  FaFacebookF,
  FaWhatsapp
} from "react-icons/fa";
import { PiInstagramLogoBold } from "react-icons/pi";

const TopHeader = () => {
  return (
    <div className="w-full bg-[#2c3e5b] text-white text-sm">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center px-4 py-2 gap-2 md:gap-0">

        {/* Left Section */}
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6">
          <div className="flex items-center gap-2">
            <FaEnvelope />
            <span className="text-[14px] sm:text-[15px]">
              info@ayanshtechnology.com
            </span>
          </div>

          <div className="flex items-center gap-2">
            <FaPhoneAlt />
            <span className="text-[14px] sm:text-[15px]">
             <b>US</b> +1-917-283-4232
            </span>
          </div>
          <div className="flex items-center gap-2">
            <FaPhoneAlt />
            <span className="text-[14px] sm:text-[15px]">
              <b>IN</b> +91-8802319226
            </span>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-4">
          <a
            href="https://www.linkedin.com/company/ayanshtech-solutions"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-sky-400 transition"
          >
            <FaLinkedinIn size={18} />
          </a>

          <a
            href="https://www.facebook.com/profile.php?id=61579642918710"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-sky-400 transition"
          >
            <FaFacebookF size={18} />
          </a>

          <a
            href="https://wa.me/8802319226"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-green-400 transition"
          >
            <FaWhatsapp size={18} />
          </a>

          <a
            href="https://www.instagram.com/ayanshtechsolutions/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-pink-400 transition"
          >
            <PiInstagramLogoBold size={18} />
          </a>
        </div>

      </div>
    </div>
  );
};

export default TopHeader;
